
import { create } from 'zustand';
import { getAttributeFilter } from '../../services/Filter/FilterService';
const useFilterStore = create((set) => ({
    gemstone: [],
    type: [],
    setGemstone: (gemstone) => set({ gemstone }),
    setType: (type) => set({ type }),
    setFilterData: async () => {
        const data = await getAttributeFilter()
        if (data && (data.Gemstone || data.Type)) {
            set({
                gemstone: data.Gemstone || [],
                type: data.Type || []
            });
        }
    },
    resetFilters: () => set({
        gemstone: [],
        type: [],
    }),
}));

export default useFilterStore;